import { Dictionary, UserProfile } from '@feedyou/schema'
import { FeedbotDispatch, GetState } from '../../../store/types'
import { AuthorId, CommentId, CommentsPatch } from '../types'
import { commentsApi, getFixedCacheKey } from '../api'
import { serverAuthorsByIdSelector } from '../selectors'
import { isPatchValidForSubmit } from '../utils'
import { openBotIdSelector } from '../../../store/app/selectors'

export const updateCommentOnServer =
  (commentId: CommentId, patch: CommentsPatch, localAuthors: Dictionary<AuthorId, UserProfile>) =>
  async (dispatch: FeedbotDispatch, getState: GetState) => {
    const botId = openBotIdSelector(getState())
    const serverAuthors = serverAuthorsByIdSelector(getState())

    const allAuthors = { ...serverAuthors, ...localAuthors }

    if (!botId) {
      console.error('Missing open bot ID')
      return
    }

    if (!isPatchValidForSubmit(patch)) {
      throw new Error('You tried to submit a comment patch which failed to validate.')
    }

    return dispatch(
      commentsApi.endpoints.updateComment.initiate(
        { patch, botId, commentId, authors: allAuthors },
        { fixedCacheKey: getFixedCacheKey.updateComment(commentId) }
      )
    ).unwrap()
  }
